// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10NyK","content":"styles_content__2e-Ha"};